define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/def",
	"csi/def/Action",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/def/ViewRef",
	"csi/form/Widget",
	"csi/locale",
	"csi/reflection",
	"dojo/store/Memory",
	"csi/store/Names",
	"csi/store/_base",
	"csi/xml",
	"csi/xml/Query"
], function(declare, lang, csi, def, Action, Field, Relationship, ViewRef, Widget, locale, reflection, Memory, Names, csiStore, xml, Query) {

	return declare(Widget, {

		ASSIGNED_SEC_GROUPS: "AssignedSecurityGroups",

		FIELD_TEMPLATE: "Template",
		FIELD_SAMPLING_PLAN: "SamplingPlan",

		FIELD_PO_LEVEL: "FinalInspectionPOLevel",
		FIELD_SHIPMENT_LEVEL: "FinalInspectionShipmentLevel",

		FIELD_INSPECTION_YEAR: "InspectionYear",
		FIELD_INSPECTION_MONTH: "InspectionMonth",

		FIELD_SHIPMENT_TERMS: "ShipmentTerms",

		/**
		 * @override
		 * Set the SamplingPlan to the SamplingPlan from the Template.
		 */
		onChangeTemplate: function(defView, field, value) {
			this.when(this.cacheView.getNodeDeferred(value), (template) => {
				if (this.getField(this.FIELD_SAMPLING_PLAN)) {
					this.setFieldValue(this.FIELD_SAMPLING_PLAN, template ? template.SamplingPlan : null);
				}
			});
		},

		/**
		 * @override
		 * Update button states based on change.
		 */
		onChangeType: function(defView, field, value) {
			this.viewParent.set("disabled", false);
		},

		/**
		 * @override
		 * When changing the style and no supplier is set, default the field with the style production supplier if available.
		 */
		onChangeStyle: function(defView, field, value) {
			if (value != csi.EMPTY_URL) {
				var supplier = this.defView.getFieldValue("Supplier");
				if (supplier == csi.EMPTY_URL) {
					var style = this.cacheView.getNode(value, true, function(req) {
						req.addDependencyPaths(["Child:ProductSourcing/Child:ProductionQuote/Child:__Parent__"]);
					});
					var sourcing = this.cacheView.getNode(style.ProductSourcing);
					if (sourcing) {
						var quote = this.cacheView.getNode(sourcing.ProductionQuote);
						if (quote) {
							var source = this.cacheView.getNode(quote.__Parent__);
							if (source) {
								this.setFieldValue("Supplier", source.Supplier);
							}
						}
					}
				}
			}
		},

		/**
		 * Enable/Disable buttons (Next, Finish) based on change.
		 * @param {View} defView
		 * @param {Field} field
		 * @param {Any} value
		 */
		onChangeShipmentTerms: function(defView, field, value) {
			this.viewParent.set("disabled", false);
		},

		/**
		 * @override
		 * Add fields as necessary, and set default values for some fields.
		 */
		_resolveView: function() {
			var fType = this.defView.getField("InspectionType");
			const fShipmentTerms = this.defView.getField(this.FIELD_SHIPMENT_TERMS);
			if (fShipmentTerms)
				fShipmentTerms.bHidden = true;

			var actionId = this.defView.getSource().m_action.m_id;
			if (actionId == "NewFinalInspection") {
				if (fType)
					fType.m_onChange = "onChangeType";

			} else {

				if (fType)
					fType.bHidden = true;

				var fStyle = this.defView.getField("Style");
				if (fStyle)
					fStyle.bHidden = true;

				var fSupplier = this.defView.getField("Supplier");
				if (fSupplier)
					fSupplier.bHidden = true;

				var fName = this.defView.getField(xml.ATTR_NAME);
				if (fName) {
					var rc = reflection.getClass("FinalInspection");
					var rca = rc.getAttribute(xml.ATTR_NAME);
					if (rca.hasActiveExpression) {
						fName.bHidden = true;
					} else {
						fName.idParameter = "Name";
					}
				}

				var fTemplate = this.defView.getField(this.FIELD_TEMPLATE);
				if (fTemplate)
					fTemplate.idParameter = this.FIELD_TEMPLATE;

				var fSamplingPlan = this.defView.getField(this.FIELD_SAMPLING_PLAN);
				if (fSamplingPlan)
					fSamplingPlan.idParameter = this.FIELD_SAMPLING_PLAN;

				switch (actionId) {

					case "NewFinalInspectionsFromPOLines":

						this.defView.addFieldAfter(lang.mixin(new Field(), {
							m_label: this.FIELD_PO_LEVEL,
							m_type: xml.ATTR_ENUM,
							m_typeControl: def.FIELD_FILTERING_SELECT,
							m_bRequired: true,
							idParameter: this.FIELD_PO_LEVEL
						}), this.FIELD_SAMPLING_PLAN);

						break;

					case "NewFinalInspectionsFromShipments":

						this.defView.addFieldAfter(lang.mixin(new Field(), {
							m_label: this.FIELD_SHIPMENT_LEVEL,
							m_type: xml.ATTR_ENUM,
							m_typeControl: def.FIELD_FILTERING_SELECT,
							m_bRequired: true,
							idParameter: this.FIELD_SHIPMENT_LEVEL
						}), this.FIELD_SAMPLING_PLAN);

						if (fShipmentTerms)
							fShipmentTerms.bHidden = false;

						break;
				}
			}

			// The getMonth() method returns the month (from 0 to 11) for the specified date, according to local time, therefore add 1
			var d = new Date();
			this.addDefaultValue(this.FIELD_INSPECTION_MONTH, xml.enumCreate(this.FIELD_INSPECTION_MONTH, d.getMonth() + 1));
			this.addDefaultValue(this.FIELD_INSPECTION_YEAR, xml.enumCreate(this.FIELD_INSPECTION_YEAR, d.getFullYear()));

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Add nodes to PO / Shipment level fields if they exist
		 */
		getFieldStore: function(field, value) {
			const fieldName = field.getControlName();
			const formParent = this.defView.m_formData.getParent();
			if (fieldName === this.FIELD_TEMPLATE && xml.nodeGetType(formParent) === "FinalInspectionSecurityGroup") {
				const {ASSIGNED_SEC_GROUPS} = this;
				// we must be inside of a Final Inspection Security Group in order to filter the templates
				const q = new Query();
				q.Or()
					// if the security group is set on the template, only show templates with that assigned security group
					.RefAttr(ASSIGNED_SEC_GROUPS, xml.OP_EQUALS, xml.nodeGetURL(formParent))
					.RefAttr(ASSIGNED_SEC_GROUPS, xml.OP_NULL)
					.RefAttr(ASSIGNED_SEC_GROUPS, xml.OP_EQUALS, csi.EMPTY_URL);
				const rel = lang.mixin(new Relationship(), {m_typeNode: "FinalInspectionTemplate", m_query: q});
				const storeOptions = csiStore.namesOptionsByRelationship(this.getContext(), rel);
				// add a blank space to the top of the list
				storeOptions.data = [csiStore.nameObject("")];
				// add Go to Dialog... with the limit query
				storeOptions.action = lang.mixin(new Action(), {
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: "InspectionTemplates",
						m_url: "centric://REFLECTION/INSTANCE/_CS_Data/null"
					}),
					m_fixedQuery: q
				});
				return new Names(storeOptions);
			} else if (fieldName === this.FIELD_PO_LEVEL) {
				return new Memory({
					data: [
						{id: this.FIELD_PO_LEVEL + ":POSupplier", name: locale.type("Supplier") + " " + locale.type("BasePurchaseOrder")},
						{id: this.FIELD_PO_LEVEL + ":PO", name: locale.type("BasePurchaseOrder")},
						{id: this.FIELD_PO_LEVEL + ":Order", name: locale.resource("Order")},
						{id: this.FIELD_PO_LEVEL + ":Colorway", name: locale.type("Colorway")}
					]
				});
			} else if (fieldName === this.FIELD_SHIPMENT_LEVEL) {
				return new Memory({
					data: [
						{id: this.FIELD_SHIPMENT_LEVEL + ":Supplier", name: locale.type("Supplier")},
						{id: this.FIELD_SHIPMENT_LEVEL + ":PO", name: locale.type("BasePurchaseOrder")},
						{id: this.FIELD_SHIPMENT_LEVEL + ":Order", name: locale.type("Order")},
						{id: this.FIELD_SHIPMENT_LEVEL + ":Shipment", name: locale.type("ShipmentTerms")}
					]
				});
			}

			return this.inherited(arguments);
		}

	});
});